import { humanizeCode } from '@/utils/billingLabels';

/** A course registration's approval stages, as the backend stores them. */
export const REGISTRATION_APPROVAL_STATUSES = [
  { label: 'Pending', value: 'pending' },
  { label: 'Level Adviser Approved', value: 'level_adviser_approved' },
  { label: 'HOD Endorsed', value: 'hod_endorsed' },
  { label: 'Rejected', value: 'rejected' },
];

/** Older rows hold capitalised words from before the stages existed. */
const LEGACY_LABELS: Record<string, string> = {
  pending: 'Pending',
  approved: 'Approved',
};

/**
 * Words for a registration's approval status: "HOD Endorsed", never the raw
 * `hod_endorsed` the course details page used to print on a warning tag.
 */
export function registrationApprovalLabel(status?: string | null, fallback = 'N/A'): string {
  if (!status) return fallback;
  return REGISTRATION_APPROVAL_STATUSES.find(s => s.value === status)?.label
    ?? LEGACY_LABELS[status.toLowerCase()]
    ?? humanizeCode(status);
}
